





































import ConfirmModal from '@/components/common/ConfirmModal.vue';
import CardInformation from '@/components/form/CardInformation.vue';
import FundCampaignMutation from '@/graphql/mutations/fundCampaign.gql';
import CampaignQuery from '@/graphql/queries/campaign.gql';
import { API_HOST, getAuthHeader, request } from '@/graphql/request';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CardInformation,
    ConfirmModal,
  },
})
export default class Donate extends Vue {
  public id: string = '';
  public campaign: {
    id: string;
    goal: number;
    quote: {
      id: string;
    };
  } = {} as any;
  public errorMessage = '';
  public bus = new Vue();
  public disabled: boolean = false;
  public paymentSucceeded: boolean = false;
  public donationInput: number | null = null;
  public isAnonymous: boolean = false;
  public modalVisible: boolean = false;
  private donationAmount!: number;

  public donateToCampaign() {
    this.errorMessage = '';
    this.modalVisible = false;
    this.disabled = true;
    this.bus.$emit('requestPaymentData');
  }

  public mounted() {
    this.id = this.$route.query.id;

    this.bus.$on(
      'paymentData',
      ({ token, name }: { token: string; name: string }) => {
        if (this.isValidDonation()) {
          const donatorName = this.isAnonymous ? undefined : name;

          request(FundCampaignMutation, {
            id: this.id,
            amount: this.donationAmount,
            paymentToken: token,
            sourceName: donatorName,
          })
            .then(({ response, errors }: any) => {
              if (errors && errors.length) {
                throw errors;
              }
              this.paymentSucceeded = true;
              window.scrollTo(0, 0);
            })
            .catch(errors => {
              this.errorMessage = this.parseErrors(errors);
              this.disabled = false;
            });
        } else {
          this.errorMessage = this.parseErrors([
            'Please enter a valid donation amount.',
          ]);
          this.disabled = false;
        }
      }
    );

    this.bus.$on('error', (message: string) => {
      this.errorMessage = message;
      this.disabled = false;
    });

    request(CampaignQuery, { id: this.id })
      .then(response => {
        if (!response || !response.data) {
          console.error('No clinic returned');
          return;
        }

        this.campaign = response.data.campaign;

        if (!this.campaign) {
          this.$router.push('/');
        }
      })
      .catch(console.error);
  }

  public formatPrice(price: number) {
    return (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  private parseErrors(errors: any) {
    const err = errors && errors[0];
    if (!err) {
      return 'Something went wrong. Please try again later.';
    }

    const msg = err.message || err;
    return typeof msg === 'string'
      ? msg
      : msg.error || 'Something went wrong. Please try again later.';
  }

  private isValidDonation() {
    if (this.donationInput && this.donationInput > 0) {
      const decimals = this.countDecimals(this.donationInput);
      if (decimals === 0 || decimals === 2) {
        this.donationAmount = this.donationInput * 100;
        return true;
      }
    }

    return false;
  }

  private countDecimals(value: number) {
    if (Math.floor(value) === value) {
      return 0;
    }
    return value.toString().split('.')[1].length || 0;
  }
}
